import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import Loading from "components/Loading";
import SpyFilter from "../filter";
import { getVideo } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import { ReactTableDataGrid } from "components/Table";
import { heightRow, INFLUENCER_CATEGORIES } from "../constant";
import { getQueryParams } from "components/Function";
import useColumnTableVideo from "../hooks/useColumnTableVideo";
import ModalPreview from "./modalPreview";

const limit = 20;

const SpyAdvancedVideo = ({ getVideo }) => {
    const { filter: initialFilter, page: initialPage } = getQueryParams();
    const [filter, setFilter] = useState(initialFilter);
    const [search, setSearch] = useState(initialFilter.keyword || "");
    const [page, setPage] = useState(initialPage);
    const [preview, setPreview] = useState(null);
    const params = useMemo(() => ({ ...filter, page, per_page: limit }), [filter, page]);
    const { data, loading } = useCallApi(getVideo, params);
    const columns = useColumnTableVideo(heightRow, setPreview);

    useEffect(() => {
        const params = new URLSearchParams({ ...filter, page });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter, page]);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <div className="card mb-5 mb-xl-10">
            <Loading isLoading={loading} />
            <div className="card-body">
                <div className="row mb-10">
                    <div className="col-md-4 d-flex align-items-center">
                        <h1 className="mb-0">Influencer</h1>
                    </div>
                    <div className="col-md-8 position-relative">
                        <div className="input-group h-100">
                            <input
                                type="text"
                                className="form-control rounded-end rounded-pill"
                                placeholder="Search..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <button
                                className="btn btn-info rounded-start rounded-pill"
                                type="button"
                                onClick={() => {
                                    setFilter((prev) => ({ ...prev, keyword: search }));
                                    setPage(1);
                                }}
                            >
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <SpyFilter
                    filter={filter}
                    filterInfluencerCategory={INFLUENCER_CATEGORIES}
                    filterCategory={[
                        {
                            label: "Influencer Category",
                            key: "influencer_categories",
                            data: INFLUENCER_CATEGORIES,
                        },
                    ]}
                    setFilter={(data) => {
                        setFilter(data);
                        setPage(1);
                    }}
                    filterShows={[
                        { label: "Region", value: "region", defaultValue: "US" },
                        { label: "Views", value: "views_count" },
                        { label: "likes", value: "likes_count" },
                        { label: "Comments", value: "comments_count" },
                        { label: "Duration", value: "duration" },
                        { label: "Affiliate", value: "is_sale" },
                        { label: "Time Range", value: "time_ranger", type: "date_picker" },
                        { label: "New Video", value: "is_latest" },
                    ]}
                />
                <div className="mt-10">
                    <ReactTableDataGrid
                        tableName="shopSpyAdvancedVideos"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                    />
                </div>
            </div>
            <ModalPreview isOpen={Boolean(preview)} onClose={() => setPreview(null)} previewLink={preview} />
        </div>
    );
};

export default connect(null, { getVideo })(SpyAdvancedVideo);
